import React, { useState, useEffect, useRef} from 'react';
import '../css/GenerateAgreement.css'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
  Box,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography,
  Button
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import PDFViewer from './PDFViewer'
import {formatDateShort, formatDate} from '../helpers/dates.js'

const TextField = (props) => {
    return (
        <div className={`grid-col column-${props?.colWidth??'any'}`} >
            <dl>
                <dt>{props.label}</dt>
                <dd className="text data" ><input type='text' className='textfield'  style={props.sx??{maxWidth: '100%'} } onChange={(e) => props.onChange(e)} value={props.value??''} /></dd>
            </dl>
        </div>
    )
}

const DateField = (props) => {
    return (
        <div className={`grid-col column-${props?.colWidth??'any'}`} >
            <dl>
                <dt>{props.label}</dt>
                <dd className="text data" ><input type='date' className='textfield'  style={props.sx??{maxWidth: '100%'} } onChange={(e) => props.onChange(e)} value={props.value??''} /></dd>
            </dl>
        </div>
    )
}

const CurrencyField = (props) => {
    return (
        <div className={`grid-col column-${props?.colWidth??'any'}`} >
            <dl>
                <dt>{props.label}</dt>
                <dd className="text data" >
                    <span style={{display: 'inline-block'}} >
                        <label className='currencylabel'>&pound;</label>
                        <input type='number' className='currencyfield'  style={props.sx??{} } onChange={(e) => props.onChange(e)} value={props.value??''} />
                    </span>
                    </dd>
            </dl>
        </div>
    )
}

const CheckBoxField = (props) => {
    return (
        <div className={`grid-col column-${props?.colWidth??'any'}`} >
            <label className='checkboxlabel'>
                <input type='checkbox' className='checkboxfield'  style={props.sx??{} } onChange={(e) => props.onChange(e)} checked={props.value??false} />
                {props.label}
            </label>
        </div>
    )
}


function GenerateAgreement(props) {
    const dispatch = useDispatch();
    const [openDialog, setOpen] = useState(props.open??false)
    const isMobile = useMediaQuery('(max-width:768px)');
    const [companyName,setCompanyName] = useState();
    const [companyNumber,setCompanyNumber] = useState("");
    const [registered_address,setRegisteredAddress] = useState("")
    const [directorName, setDirectorName] = useState("")
    const [email, setEmail] = useState("")
    const [fee, setFee] = useState(5000)
    const [contractDate,setContractDate] = useState(new Date().toISOString().substring(0,10))
    const [pdf,setPdf] = useState('')
    const [showPdf,setShowPdf] = useState(false)
    const [taxpdf,setTaxPdf] = useState('')
    const [showTaxPdf, setTaxShowPdf]=useState(false)
    const [taxForm, setTaxForm] = useState({cis:false, vat: false, corp: false, paye:false})
    const [mergetaxform,setMergeTaxform] = useState(true)
    const [signingDisabled,setSigningDisabled] = useState(true)
    const [sending,setSending]=useState(false)

    const company = useSelector(state => state.chouse.company);
    const filings = useSelector(state => state.chouse.filings, shallowEqual)

    const ch_companyNumber = useSelector(state => state.chouse.companyNumber, shallowEqual)
    const ch_companyName = useSelector(state => state.chouse.companyName, shallowEqual)
    const ch_regaddr = useSelector(state => state.chouse.registered_office_address, shallowEqual)
    const ch_regaddr_parts = useSelector(state => state.chouse.company.registered_office_address)
    const data_name = useSelector(state=> state.data.rowdata.FullName,shallowEqual)
    const data_email = useSelector(state=> state.data.rowdata.Email,shallowEqual)
    const token = useSelector(state=> state.auth.token, shallowEqual)
    const Phone = useSelector(state=> state.auth.phone, shallowEqual)
    const loaded = useSelector(state => state.chouse.loaded, shallowEqual)
    const uid = useSelector(state=> state.data.rowdata.uid,shallowEqual)

    function timeout(delay: number) {
        return new Promise( res => setTimeout(res, delay) );
    }

        useEffect(() => {
            async function SendViaDocuSign() {
                try {
                    const rec = {signerName: directorName, signerEmail: email, signFile: pdf}
                    const url = 'https://portal.ttpadvisory.co.uk:3556/api/pdfmerge/sendforsigning'
                    const docus = await fetch(url,{
                        method: 'POST',
                        headers: {
                            'Content-Type':'application/json',
                            'Authorization':`Bearer ${token}`
                        },
                        body: JSON.stringify(rec)
                    })
                    console.log(docus)
                    if(docus.ok) {
                        const docujson = await docus.json();
                        console.log(docujson)
                        if(docujson.status) {
                            alert(`The Document has been sent for Signing. The Envelope ID is ${docujson.data}`)
                        }else {
                            alert(`The Following Error occured whilst sending the document for signing:\n\n${docujson.err}`)
                        }
                    }
                    setSending(false) 
                }catch(err) {
                    console.log(`Error Sending Document!`,err)
                    setSending(false)  
                    alert(`There was an Error Submitting the Document to DocuSign:\n\n${err.toString()}`)
                }
      
           }
            if(sending)
                SendViaDocuSign()
        },[sending])

        

    useEffect(() => {
        if(openDialog !== (props.open??false)) 
            setOpen(props.open??false)
    },[props.open,openDialog,setOpen])

    useEffect(()=> {
        if(loaded && (ch_companyName??'') !== '' ) {
            setCompanyName(ch_companyName??'');
            setCompanyNumber(ch_companyNumber??'');
            setRegisteredAddress(ch_regaddr??'');
            setDirectorName(data_name??'');
            setEmail(data_email??'');
            setShowPdf(false)
        }

    },[loaded, ch_companyName, ch_companyNumber, ch_regaddr,data_name, data_email])

    const closeDialog = () => {
        setOpen(false)
        props.onClose(false)
    }

    const updateCompanyName = (e) => {
        setCompanyName((e.target.value??'').toUpperCase())
    }

    const updateCompanyNumber = (e) => {
        setCompanyNumber(e.target.value)
    }

    const updateRegisteredAddress = (e) => {
        setRegisteredAddress(e.target.value)
    }

    const updateDirectorName = (e) => {
        setDirectorName(e.target.value)
    }

    const updateEmail= (e) => {
        setEmail(e.target.value.toLowerCase())
    }

    const updateFee = (e) => {
        setFee(e.target.value);
    }

    const updateContractDate = (e) => {
        setContractDate(e.target.value)
    }

    const updateMergeTaxAgent = (e) => {
        setMergeTaxform(e.target.checked)
    }

    const updateTaxForm = (field,e) => {
        setTaxForm((state) => ({...state,[field]:e.target.checked}))
    }

    const createContract = async () => {


        const data = [
            {pdf: 'CompanyName', data:companyName, format: 'Uppercase'},
            {pdf: 'CompanyNumber', data:companyNumber},
            {pdf: 'RegisteredAddress', data:registered_address},
            {pdf: 'ContractDate', data:formatDate(contractDate)},
            {pdf: 'Fee', data:fee, format: 'Currency'},
            {pdf: 'CompanyNameAddress', data:`${companyName}, ${registered_address}`},
            {pdf: 'DirectorName', data: directorName, format: 'Uppercase'},

        ];
        const url = 'https://portal.ttpadvisory.co.uk:3556/api/pdfmerge/mergepdfform'
        const ret = await fetch(url,{
            method: 'POST',
            headers: {
                'Content-Type':'application/json',
                'Authorization':`Bearer ${token}`
            },
            body: JSON.stringify({data, templatename: 'TTP_Contract_V2', companynumber: companyNumber})
        })
        console.log(ret)
        if(ret.ok) {
            const res = await ret.json();
            console.log(res)
            if(res.status) {
                setPdf(res.data)
                setShowPdf(true)
                setSigningDisabled(false)
            }
        }
        if(mergetaxform ) {
            await processTaxForm();
        }
    }

    const processTaxForm = async () => {
        const { address_line_1,address_line_2,country,locality,postal_code} = ch_regaddr_parts
        const data = [
            {pdf: 'txtName', data:directorName, format: 'Uppercase' },
            {pdf: 'AgentsPhoneNumber', data: Phone, format: 'Uppercase' },
            {pdf: 'txtCompanyName', data: companyName, format: 'Uppercase'},
            {pdf: 'chkCorpTax', data:taxForm.corp, format:'checkbox'},				// Check Box to Deal with Corp Tax
            {pdf: 'chkVAT', data: taxForm.vat, format:'checkbox' },  
            {pdf: 'chkTaxcredits', data: false, format:'checkbox'},			// Check Box to Deal with VAT
            {pdf: 'chkVATDIY', data:taxForm.vathomebuilder, format:'checkbox' },
            {pdf: 'chkCIS', data: taxForm.cis, format:'checkbox' },					// Check Box to deal with CIS
            {pdf: 'chkAuthAgent CIS2', data:taxForm.cis, format:'checkbox' },		// Check Box Authorising us to receive info by Phone and in Writing
            {pdf: 'chkEmp PAYE scheme', data: taxForm.paye, format:'checkbox'},	// Check Box to deal with Employers PAYE
            {pdf: 'EMPchkAuthAgent CIS', data: taxForm.paye, format:'checkbox' },	// PAYE Check Box Authorising us to receive info by Phone and in Writing
            {pdf: 'chkSA', data: false, format:'checkbox'},
            {pdf: 'Client ref', data:`TTP-${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2,"0")}-${uid}`},
            {pdf:'YourAddress1', data: address_line_1??'', format: 'Uppercase' },
            {pdf:'YourAddress2', data: address_line_2??'', format: 'Uppercase' },
            {pdf:'YourAddress3', data: locality??'', format: 'Uppercase'},
            {pdf:'YourPost code', data: postal_code??'', format: 'Uppercase'}
        ];
        


        const url = 'https://portal.ttpadvisory.co.uk:3556/api/pdfmerge/mergepdfform'
        const rettax = await fetch(url,{
            method: 'POST',
            headers: {
                'Content-Type':'application/json',
                'Authorization':`Bearer ${token}`
            },
            body: JSON.stringify({data, templatename: 'HMRC_64_8_2024', companynumber:companyNumber})
        })
        console.log(rettax)
        if(rettax.ok) {
            const restax = await rettax.json();
            console.log(restax)
            if(restax.status) {
                setTaxPdf(restax.data)
                setTaxShowPdf(true)
            }
        }
    }
    const  sendForSigning = async () => {
        if(directorName ==="")
            return alert("The Directors Email Address must be completed!")

        if(email ==="")
            return alert("The Directors Name must be completed!")

        if(pdf ==="")
            return alert("A PDF Must me completed before you can continue")
        setSending(true)




    }
    if(loaded)
    return (
        <Dialog
            open={openDialog}
            onClose={() => closeDialog()}
            fullWidth={true}
            maxWidth='lg'     
            sx={{position: 'absolute', top:0, bottom:0,left: 0,right: 0}}       
        >
              <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
                <h2>Generate Customer Contract</h2>
                <IconButton
                aria-label="close"
                onClick={closeDialog}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
                >
                <CloseIcon />
                </IconButton>
            </DialogTitle>
            {!loaded && <div>Loading Data from Companies House....</div>}
            {loaded && <DialogContent>
                
                <div className='grid-row' >
                    <TextField  label='Company Number' value={companyNumber} onChange={updateCompanyNumber} sx={{width: '8ch'}} />
                    <TextField  label='Company Name' value={companyName} onChange={updateCompanyName} sx={{width: '120ch'}} />
                </div>
                <div className='grid-row' >
                    <TextField  label='Registered Address' value={registered_address} onChange={updateRegisteredAddress} colWidth='full' />
                </div>
                <div className='grid-row' >
                    <TextField  label='Directors Name' value={directorName} onChange={updateDirectorName} colWidth='half' />
                    <TextField  label='Email Address' value={email} onChange={updateEmail}  colWidth='half' />
                </div>

                <div className='grid-row' >
                    <DateField  label='Contract Date' value={contractDate} onChange={updateContractDate} />
                    <CurrencyField  label='Fee' value={fee} onChange={updateFee}  />
                    <input type='button' className='btn' value='GENERATE CONTRACT' onClick={()=>createContract()} />
                    <input type='button' className='btn' onClick={sendForSigning} disabled={signingDisabled} value='SEND CONTRACT FOR SIGNING' />
                    <CheckBoxField label='Create Tax Agent Form' value={mergetaxform} onChange={updateMergeTaxAgent}  />
                </div>
                {sending && <CircularProgress size="6rem" style={{width: '6rem', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} /> }
                {mergetaxform &&
                    <div className='grid-row' >
                        <div className='grid-column' >
                            <span className='checkboxlabel' style={{marginRight: '10px'}}>Which Tax Areas are we dealing with:</span>
                            <CheckBoxField label='CORP' value={taxForm.corp} onChange={(e) => {updateTaxForm('corp',e)}}  /> 
                            <CheckBoxField label='VAT' value={taxForm.vat} onChange={(e) => {updateTaxForm('vat',e)}}  /> 
                            <CheckBoxField label='PAYE' value={taxForm.paye} onChange={(e) => {updateTaxForm('paye',e)}}  /> 
                            <CheckBoxField label='CIS' value={taxForm.cis} onChange={(e) => {updateTaxForm('cis',e)}}  /> 
                        </div>
                    </div>
                }
                {showPdf &&
                  <Box
                  sx={{
                    height: '70vh',                 // controls height of the scroll area
                    overflow: 'hidden',             // contain scroll within this box
                    border: '1px solid #ccc',
                    borderRadius: 1,
                  }}
                >
                    <PDFViewer filename={pdf} />
                </Box>
                }
                {showTaxPdf && mergetaxform && 
                        <Box
                        sx={{
                        height: '70vh',                 // controls height of the scroll area
                        overflow: 'hidden',             // contain scroll within this box
                        border: '1px solid #ccc',
                        borderRadius: 1,
                        }}
                    >
                        <PDFViewer filename={taxpdf} />
                    </Box>
                }
                <Button onClick={() => closeDialog()}>Close</Button>
            </DialogContent>}
        </Dialog>
    )

}


export default GenerateAgreement;